import {StockMovementAuditReportModel} from "./stock-movement-audit-report.model";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-stock-movement-audit-report",
    templateUrl: "./stock-movement-audit-report.component.html",
    providers: [provideReportModel(StockMovementAuditReportModel)]
})
export class StockMovementAuditReportComponent extends AbstractReportPage {

    constructor(public model: StockMovementAuditReportModel) {
        super();
    }
}
